import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import Header from '../components/Header';
import Breadcrumb from '../components/Breadcrumb';
import usePageMeta from '../utils/usePageMeta';

const UhOhTooEarlyPage = () => {
  const { page, provider, leagueYear, leagueId } = useParams();

  usePageMeta({
    title: "You're a Bit Early",
    description: 'This page is not yet available for the current season. Please check back later.',
  });

  const message = () => {
    if (page === 'league-homepage') {
      return "League homepages are not accessible until Week 1 has begun. Please check back once the season kicks off.";
    } else if (page === 'playoff-simulations') {
      return "Playoff simulations are not accessible until Week 4 has completed. Check back once the early weeks are in the books.";
    }
    return "This page is not available yet. Please check back later.";
  };

  const breadcrumbItems = [
    { label: 'Dashboard', to: '/dashboard' },
    ...(leagueYear && leagueId && page !== 'league-homepage'
      ? [{ label: 'League', to: `/fantasy_stats/league/${provider}/${leagueYear}/${leagueId}` }]
      : []),
    { label: "You're a Bit Early" },
  ];

  return (
    <div className="min-h-screen bg-bg flex flex-col">
      <Header />

      {/* Hero Band */}
      <div className="bg-forest border-b-4 border-mustard">
        <div className="max-w-5xl mx-auto px-6 py-8">
          <Breadcrumb items={breadcrumbItems} />
          <div className="flex items-center gap-3 mt-1">
            <Clock className="w-8 h-8 text-mustard flex-shrink-0" aria-hidden="true" />
            <h1 className="font-display text-4xl font-black text-white leading-none">
              You're a Bit Early!
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <main className="flex-1 max-w-5xl mx-auto w-full px-4 sm:px-6 py-12">
        <div className="bg-surface border border-border-card rounded-card shadow-card p-8 max-w-xl">
          <p className="text-ds-text font-sans text-base leading-relaxed mb-2">
            {message()}
          </p>
          <p className="text-text-muted font-sans text-sm mb-6">
            Thank you for your patience!
          </p>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/dashboard"
              className="px-5 py-2.5 bg-mustard text-forest font-sans font-extrabold text-sm rounded-lg shadow-mustard hover:bg-yellow-500 transition-colors"
            >
              Back to Dashboard
            </Link>
            {page !== 'league-homepage' && leagueYear && leagueId && (
              <Link
                to={`/fantasy_stats/league/${provider}/${leagueYear}/${leagueId}`}
                className="px-5 py-2.5 text-forest font-sans font-bold text-sm border border-border rounded-lg hover:bg-green-light transition-colors"
              >
                Return to Your League
              </Link>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default UhOhTooEarlyPage;
